import { Component, OnInit, ElementRef, AfterViewInit, ChangeDetectorRef, HostListener, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { StripePurchasePopupComponent } from 'src/app/features/bulk-purchase/stripe-purchase-popup/stripe-purchase-popup.component';
import { EventType } from 'src/app/features/passport/models/passport.models';
import { BookmarkPopupComponent } from 'src/app/features/spotlight/bookmark-popup/bookmark-popup.component';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UnlockPopupComponent } from 'src/app/features/spotlight/unlock-popup-component/unlock-popup-component.component';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-movie',
  templateUrl: './movie.component.html',
  styleUrls: ['./movie.component.css'],
})
export class MovieComponent implements OnInit, AfterViewInit {
  private static readonly stripePaymentEventKey = 'stripe_payment_showcase';

  category: string;
  emotions: any = [];
  Genre: any = [];
  movieList: any = [];
  backArrow: any = 'assets/images/cinejoy/arrow-left.png';
  officialLogo = "assets/images/spotlight/Laurel.svg"
  movie: any = [];
  additionalMedia: any = [];
  eventImage: any = [];
  Shorts: any = [];
  starCast: any = [];
  name: any;
  ShortDescriptive1: any = [];
  description: any = [];
  country: any = [];
  AllmovieList: any = [];
  mobilemovieList: any = [];
  rating: number;
  language: string;
  duration: any;
  tags: any = [];
  id: any;
  dates: any;
  subCat: any = [];
  subCategories: any = [];
  filtermovieList: any[];
  public errorApi = false;
  type: any;
  movieDisplayed: any;
  movieId: any;
  purchaseCallback = false;
  pageUrl: string = '';
  showcaseTickets: any = new Array();
  isBuyButtonActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  subscriptionList!: any[];
  isButtonClicked: boolean = false;
  availableTicketIdList: number[] = [];
  pass = true
  isScreenSmall:boolean = false;
  selectedYear: any;
  @ViewChild('descriptionScrollContainer') descriptionScrollContainer: ElementRef;
  constructor(
    public showcaseService: ShowcaseService,
    private router: Router,
    private readonly route: ActivatedRoute,
    private modalService: NgbModal,
    public dialog: MatDialog,
    private adminService: AdminService,
    private spotlightService: SpotlightService,
    private agileIntegration: AgileIntegrationService,
    private authService: AuthenticationService,
    private cdRef: ChangeDetectorRef,
    private meta: Meta,
    private titleService: Title
  ) { }

  ngOnInit() {
    if (this.router.url.includes('archive')) {
      this.pass = false
    }
    this.checkForPurchaseCallback();
    this.loadMovieSelectionFromStorage();
    this.populateMovieList();
    this.checkActiveSubscription();
    this.populateCallbackUrl();
    this.checkScreenSize()
    this.authService.checkUserAuthenticated().subscribe((res) => {
      if (res.userId > 0) {
        this.showcaseService.fetchTickets();
      }
    },
      (err) => { }
    );

  }

  sortMovies(array: any[], field: string, order: 'asc' | 'desc' = 'asc'): any[] {
    return array.slice().sort((a, b) => {
      const comparison = a[field].localeCompare(b[field]);
      return order === 'asc' ? comparison : -comparison;
    });
  }

  private populateMovieList() {
    this.showcaseService.categoryObs$.subscribe((res) => {
      let item = JSON.parse(res);
      this.category = item.category;
      this.type = item.type;
      this.subCat = item.subCategories;
      this.selectedYear = item?.year
      this.movieList = []
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      this.errorApi = false;
      if (this.router.url.includes('/archive')) {
        if (this.selectedYear >= 2025) {
          this.showcaseService
            .getArchivedShowcaseList(this.category, this.subCat, this.type)
            .subscribe(
              (res) => {
                this.movieList = res.moviesArray;
                if (this.movieList.length <= 0) {
                  this.errorApi = false;
                }
                this.movieDisplayed = this.movieList[0];
                this.movieId = this.movieDisplayed.id;
                this.checkForTicket();
                if (this.availableTicketIdList.includes(this.movieDisplayed?.eventId)) {
                  this.isBuyButtonActive.next(false)
                }
                this.checkActiveSubscription();
                this.movieDisplayed = this.movieList[0];
              },
              (err) => {
                this.errorApi = true;
              }
            );
        }
        else {
          this.showcaseService
            .getShowcaseArchiveListOnCategory(this.category, this.type, this.subCat, this.selectedYear)
            .subscribe(
              (res) => {
                this.movieList = res['body'].moviesArray;
                if (this.movieList.length <= 0) {
                  this.errorApi = true;
                }
                this.movieDisplayed = this.movieList[0];
                this.movieId = this.movieDisplayed.id;
                this.checkForTicket();
                if (this.availableTicketIdList.includes(this.movieDisplayed?.eventId)) {
                  this.isBuyButtonActive.next(false);
                }
                this.checkActiveSubscription();
              },
              (err) => {
                this.errorApi = true;
              }
            );
        }
      } else {
        // cms data
        this.showcaseService
          .getCinejoyAdminShowcaseMoviesByCategories(this.category, this.subCat, this.type)
          .subscribe(
            (res) => {
            res.moviesArray = this.sortMovies(res.moviesArray,'name','asc')
              this.movieList = res.moviesArray;
              if (this.movieList.length <= 0) {
                this.errorApi = true;
              }

              this.movieDisplayed = this.movieList[0];
              this.movieId = this.movieDisplayed?.id;
              this.checkForTicket();
              if (this.availableTicketIdList.includes(this.movieDisplayed?.eventId)) {
                this.isBuyButtonActive.next(false);
              }
              this.checkActiveSubscription();
              this.movieDisplayed = this.movieList[0];

            },
            (err) => {
              this.errorApi = true;
            }
          );
      }
    });
  }

  private loadMovieSelectionFromStorage() {
    if (sessionStorage.getItem('movieNavigation') !== null) {
      this.showcaseService.categoryObs$.next(
        sessionStorage.getItem('movieNavigation')
      );
    }
  }

  ngAfterViewInit(): void {
    this.checkForTicket();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    this.showcaseService.scrollObs$.subscribe((res) => {
      if (this.movieId !== res.replace('movies', '')) {
        this.movieId = res.replace('movies', '');
        if (document.getElementById(res)) {
          document.getElementById(res).scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
          this.movieDisplayed = this.movieList.find(
            (v) => v.id == res.replace('movies', '')
          );
          this.checkForTicket();
          this.isBuyButtonActive.next(true);
          this.checkActiveSubscription();
          if (this.availableTicketIdList.includes(this.movieDisplayed?.eventId)) {
            this.isBuyButtonActive.next(false);
          }
        }
      } 
    });
  }

  onShowcaseMovieClick(res){
      this.cdRef.detectChanges();
      if (this.movieId !== res.replace('movies', '')) {
        this.movieId = res.replace('movies', '');
        if (document.getElementById(res)) {
          document.getElementById(res).scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
          this.movieDisplayed = this.movieList.find(
            (v) => v.id == res.replace('movies', '')
          );
          this.checkForTicket();
          this.isBuyButtonActive.next(true);
          this.checkActiveSubscription();
          if (this.availableTicketIdList.includes(this.movieDisplayed.eventId)) {
            this.isBuyButtonActive.next(false);
          }
        }
      } else {
        this.movieId = res.replace('movies', '');
        this.movieDisplayed = []
        if (document.getElementById(res)) {
  
          this.movieDisplayed = this.movieList.find(
            (v) => v.id == res.replace('movies', '')
          );
          this.checkForTicket();
          this.isBuyButtonActive.next(true);
          this.checkActiveSubscription();
          if (this.availableTicketIdList.includes(this.movieDisplayed.eventId)) {
            this.isBuyButtonActive.next(false);
          }
        }
      }
  }

  openPaymentFlow(id: number, movieDetails: any, purchaseStage: string): void {
    if (!environment.showcaseAgilePurchaseEnabled) {
      if (this.isButtonClicked) {
        return;
      }
      this.isButtonClicked = true;

      this.authService.checkUserAuthenticated().subscribe({
        next: (user) => {
          if (user.userId > 0) {
            localStorage.setItem(MovieComponent.stripePaymentEventKey, JSON.stringify(movieDetails));
            this.dialog.open(StripePurchasePopupComponent, {
              panelClass: 'custom-dialog-padding',
              width: '470px',
              height: 'auto',
              position: { top: '20px' },
              data: {
                eventId: id,
                eventType: EventType.SHOWCASE,
                showcaseEvent: movieDetails,
                url: this.pageUrl,
                mode: 'purchase',
                puchaseType: 'singlePurchase',
                purchaseTransactionType: 'TICKET'
              }
            }).afterClosed().subscribe((res) => {
              this.isButtonClicked = false;
            })
          }
          else {
            alert('Please login to Creatics to purchase tickets.');
            location.href = '/login?referer=cinejoy/showcase/features';
          }
        },
        error: (err) => {
          console.log(err);
          alert('Please login to Creatics to purchase tickets.');
          location.href = '/login?referer=cinejoy/showcase/features';
        }
      })
    } else {
      const modalRef = this.modalService.open(PurchaseFlowComponent, {
        size: 'lg',
        backdrop: 'static',
      });
      modalRef.componentInstance.eventId = id;
      modalRef.componentInstance.premiere = movieDetails;
      modalRef.componentInstance.purchaseStage = purchaseStage;
    }
  }

  imgDetail(movie) {
    if (movie.id !== this.movieDisplayed.id) {
      this.movieDisplayed = movie;
      this.showcaseService.scrollObs$.next(`movies${movie.id}`);
      setTimeout(() => {
        this.descriptionScrollContainer.nativeElement.scrollTop = 0;
      }, 100);
    }

  }

  navigateMovieInfo(event) {
    this.router.navigateByUrl(`/cinejoy/showcase/moviepage/${event.id}/${this.getmovieName(event.name)}`)
  }

  share(url) {
    return window.open(
      url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=300,width=700,height=700'
    );
  }

  getmovieName(moviename) {
    let name = ''
    if (moviename) {
      name = moviename.replace(/[\s?]/g, '-');
    }
    return name;
  }
  checkForPurchaseCallback() {
    const premiere = JSON.parse(localStorage.getItem(MovieComponent.stripePaymentEventKey));
    this.route.queryParams.subscribe((queryParams) => {
      if (this.router.url.includes('session_id')) {
        this.openStripPaymentConfirmationPopup(premiere?.eventId, premiere, queryParams.session_id);
      }
    })
  }

  openStripPaymentConfirmationPopup(eventId, event, sessionId) {
    const premiere = JSON.parse(localStorage.getItem(MovieComponent.stripePaymentEventKey));
    this.dialog
      .open(StripePurchasePopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '600px',
        minHeight: 'auto',
        maxHeight: '75%',
        data: {
          eventId: eventId,
          eventType: EventType.SHOWCASE,
          showcaseEvent: event,
          mode: 'callback',
          sessionId: sessionId,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        this.showcaseService.fetchTickets();
        this.populateCallbackUrl();
        this.checkForTicket();
        this.isBuyButtonActive.next(false);
        if (this.availableTicketIdList.includes(this.movieDisplayed?.eventId)) {
          this.isBuyButtonActive.next(false);
        }
        this.checkActiveSubscription();
      });
  }

  private populateCallbackUrl() {
    this.pageUrl = window.location.href;
  }
  checkForTicket() {
    this.showcaseService.ShowcaseTicketAndSubscriptionListObs$.subscribe({
      next: (tickets) => {
        tickets.map(ticket => {
          if (ticket.purchaseTransactionType === 'TICKET') {
            this.availableTicketIdList.push(ticket.ParentID);
          }
        })
      }
    })
  }

  checkActiveSubscription() {
    this.showcaseService.ShowcaseTicketAndSubscriptionListObs$.subscribe({
      next: (tickets) => {
        tickets.map(ticket => {
          if (this.movieDisplayed && (ticket.purchaseTransactionType === 'SUBSCRIPTION_ALL' || ticket.purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE')) {
            this.isBuyButtonActive.next(false);
          }
        }
        )
      }
    })
  }


  navigateToMovieInfo(selectedMovie) {
    this.router.navigate(['/cinejoy/showcase/moviepage', selectedMovie?.id, this.getmovieName(selectedMovie.name), selectedMovie?.cinejoyYears ? parseInt(selectedMovie?.cinejoyYears) : ''])
  }

  bookmarkEvent(eventId: number, isBookmarked: boolean): void {
    this.adminService.getActiveSubscription().subscribe((res) => {
      if (res && res.length > 0 && res[0].purchaseTransactionType === 'SUBSCRIPTION_ALL') {
        const confirmationMessage = isBookmarked
          ? "Do you want to add this event to your Watchlist?"
          : "Do you want to remove this event from your Watchlist?";
        if (window.confirm(confirmationMessage)) {
          this.spotlightService.createOrUpdatePassholderWatchlist(eventId, isBookmarked, 'SHOWCASE').subscribe((res) => {
            if (res) {

              this.dialog.open(BookmarkPopupComponent, {
                data: { isBookmarked },
              });

              this.populateMovieList();
            }
          });
        }

      } else {
        this.dialog.open(UnlockPopupComponent, {
          panelClass: 'zero-padding-dialog',
          data: { message: 'My Watchlist is an ' + '<a style="color: white !important;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>' + ' holder’s feature that allows you to bookmark and organize your event and screening experience.' },
        });
      }
    });
  }
  alreadyBookmarkEvent(isBookmarked: boolean) {
    this.dialog.open(BookmarkPopupComponent, {
      data: { isBookmarked }
    }
    )
  }

  shareButton(type: string) {
    let searchParams = new URLSearchParams();
    let url: string;
    const systemUrl = environment.apiURL + `cinejoy/showcase/moviepage/${this.movieDisplayed.id}/${this.getmovieName(this.movieDisplayed.name)}/${this.movieDisplayed.cinejoyYears}`;
    switch (type) {
      case 'facebook':
        const baseUrl = new URL('https://www.facebook.com/sharer/sharer.php');
        const encodedUrl = encodeURIComponent(systemUrl);
        const encodedQuote = encodeURIComponent(this.movieDisplayed.name);
        const encodedDescription = encodeURIComponent(this.movieDisplayed.description);
        const shareUrl = `${baseUrl}?u=${encodedUrl}&title=${encodedQuote}`;
        this.titleService.setTitle(this.movie.name);

        this.meta.updateTag({ property: 'og:title', content: this.movieDisplayed.name });
        this.meta.updateTag({ property: 'og:description', content: this.movieDisplayed.description });
        this.meta.updateTag({ property: 'og:image', content: this.movieDisplayed.eventImage });
        this.meta.updateTag({ property: 'og:url', content: systemUrl });
        setTimeout(()=>{
          this.share(shareUrl.toString());
        },2000)
        break;

      case 'twitter':
        searchParams.set('url', "\n"+environment.apiURL + `cinejoy/showcase/moviepage/${this.movieDisplayed.eventId}/${this.getmovieName(this.movieDisplayed.name)}/${this.movieDisplayed.cinejoyYears}`);
        searchParams.set('title', this.movieDisplayed.name);
        searchParams.set('text', '\nExperience the Cinejoy Film Festival on Creatics.');
        url = 'https://twitter.com/share?' + searchParams;
        this.share(url);

        break;

      case 'email':
        const emailBody = encodeURIComponent(`Check out this movie: ${this.movieDisplayed.name}\n\n${this.stripHtml(this.movieDisplayed.description)}\n\n${systemUrl}`);
        url = `mailto:?subject=${encodeURIComponent(this.movieDisplayed.name)}&body=${this.stripHtml(emailBody)}`;
        this.share(url);
        break;

      case 'pinterest':
        const pinterestURL = encodeURIComponent(environment.apiURL + `cinejoy/showcase/moviepage/${this.movieDisplayed.eventId}/${this.getmovieName(this.movieDisplayed.name)}/${this.movieDisplayed.cinejoyYears}`);
        const imageURL = encodeURIComponent(this.movieDisplayed.image); // Provide the image URL
        const description = encodeURIComponent(this.movieDisplayed.description);
        url = `https://www.pinterest.com/pin/create/button/?url=${pinterestURL}&media=${imageURL}&description=${description}`;
        this.share(url);
        break;

      case 'copy-link':
        const linkToCopy = environment.apiURL + `cinejoy/showcase/moviepage/${this.movieDisplayed.eventId}/${this.getmovieName(this.movieDisplayed.name)}/${this.movieDisplayed.cinejoyYears}`;
        this.copyToClipboard(linkToCopy);
        break; // No need to open a URL for copying

      case 'instagram':
        const instagramMessage = `Check out this movie: ${this.movieDisplayed.name}\n\n${this.stripHtml(this.movieDisplayed.description)}\n\n${systemUrl}`;
        url = `https://www.instagram.com/?text=${encodeURIComponent(instagramMessage)}&url=${encodeURIComponent(url)}`;
       // alert(`Share this on Instagram:\n\n${this.stripHtml(instagramMessage)}`);

        navigator.clipboard.writeText(instagramMessage).then(() => {
          alert(`Text copied! Now go to Instagram and paste it.\n\n${this.stripHtml(instagramMessage)}`);
          this.share(url);

        }).catch(err => {
          console.error('Failed to copy:', err);
          alert('Failed to copy text. Please try again.');
        });
        break; // No URL for Instagram, but you can redirect if needed

      default:
        console.error('Unsupported share type:', type);
        break;
    }

  }


  stripHtml(html: string): string {
    return html?.replace(/<[^>]+>/g, ''); 
  }

  copyToClipboard(text: string) {
    if (document.hasFocus()) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            alert('Link copied to clipboard!');
          })
          .catch((err) => {
            console.error('Clipboard API failed. Error:', err);
          });
      } else {
        this.fallbackCopyToClipboard(text);
      }
    } else {
      this.fallbackCopyToClipboard(text);
    }
  }

  // Fallback method for older browsers
  fallbackCopyToClipboard(text: string) {
    try {
      const tempInput = document.createElement('textarea');
      tempInput.value = text;
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px'; // Move off-screen
      document.body.appendChild(tempInput);
      tempInput.focus();
      tempInput.select();

      const successful = document.execCommand('copy');
      if (successful) {
        alert('Link copied to clipboard!');
      } else {
        console.error('Fallback: Copy command failed.');
      }
    } catch (err) {
      console.error('Fallback: Unable to copy text. Error:', err);
      alert('An error occurred while trying to copy the link. Please try again.');
    } finally {
      const tempInput = document.querySelector('textarea');
      if (tempInput) {
        document.body.removeChild(tempInput);
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  checkScreenSize() {
    this.isScreenSmall = window.innerWidth < 760;
    if(this.isScreenSmall){
      this.router.navigate(['/cinejoy/showcase'])
    }
  }
}
